<script>
    export default {
        name: "FChartPie",

        props: {
            labelsKey: {
                type: String
            },

            seriesKey: {
                type: String
            },

            rawData: {
                type: Array
            }
        },

        methods: {
            dynamicSort(property) {
                var sortOrder = 1;

                if (property[0] === "-") {
                    sortOrder = -1;
                    property = property.substr(1);
                }

                return function(a, b) {
                    if (sortOrder == -1) {
                        return b[property].localeCompare(a[property]);
                    } else {
                        return a[property].localeCompare(b[property]);
                    }
                };
            }
        },

        watch: {
            rawData() {
                const sorted = [...this.rawData].sort(
                    this.dynamicSort(this.labelsKey)
                );

                const { labels, series } = sorted.reduce(
                    (acc, cur) => ({
                        labels: [...acc.labels, cur[this.labelsKey]],
                        series: [...acc.series, cur._fields[this.seriesKey]]
                    }),
                    { labels: [], series: [] }
                );

                this.labels = labels;
                this.series = series;
            }
        },

        computed: {
            render() {
                return this.series.length > 0 && this.labels.length > 0;
            }
        },

        data: () => ({
            labels: [],
            series: [],
            chartOptions: {
                legend: {
                    position: "bottom",
                    horizontalAlign: "left",
                    fontSize: 14,
                    itemMargin: {
                        vertical: 20
                    },
                    labels: {
                        colors: "#000"
                    }
                },

                plotOptions: {
                    pie: {
                        customScale: 1.25
                    }
                }
            }
        })
    };
</script>

<template>
    <div class='fluid__chart--pie'>
        <apexchart type='pie' v-if='render' :options='{...chartOptions, labels}' :series='series'/>
    </div>
</template>

<style>
    .fluid__chart--pie {
        width: 100%;
        max-width: 400px;
        margin-bottom: 10px;
    }

    .apexcharts-legend-series {
        width: 100%;
    }
    .apexcharts-legend {
        position: absolute;
    }
</style>

